import React, { useState, useEffect } from 'react'
import { useParams } from "react-router-dom";
import VisualizacaoPadrao from '../../../../components/VisualizacaoPadrao'
import { visualizar } from '../../../../util/AcessoApi'
import { ordenarArrayObj, downloadArquivoS3 } from '../../../../util/FuncoesComuns'

export default props => {
    let { id } = useParams()
    const [dados, setDados] = useState(null)

    useEffect(() => {
        if (id)
            visualizar(`/estoque/produtoentradasaida`, id, obj => { setDados(obj); console.log('obj: ', obj); })
    }, [id])

    let data = { titulo: 'Visualização de Produto Entrada/Saída' }

    if (dados && dados.id) {
        if (dados.operacao.value == 1)
            data.grupos = [
                {
                    titulo: 'Dados Gerais',
                    colunas: [
                        {
                            titulo: 'Código',
                            descricao: dados.id,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Operação',
                            descricao: dados.operacao && dados.operacao.label,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Código de Barras',
                            descricao: dados.produto.codigo_barras,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Produto',
                            descricao: dados.produto.label,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Data Entrada',
                            descricao: dados.data,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Quantidade',
                            descricao: dados.quantidade,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Fornecedor',
                            descricao: dados.responsavel && dados.responsavel.label,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'N° Serie/Lote',
                            descricao: dados.lote,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Nota Fiscal/Contrato',
                            descricao: dados.nota_fiscal,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Custo Unitário',
                            descricao: dados.custo_unitario,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Custo Total',
                            descricao: dados.custo_total,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Validade',
                            descricao: dados.validade,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'TAG (Cliente)',
                            descricao: dados.cliente && dados.cliente.label,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Observação',
                            descricao: dados.observacao,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Data Registro',
                            descricao: dados.data_registro,
                            tamanho: 'col-lg-6'
                        }
                    ]
                }, {
                    tipoGrupo: 'tabela',
                    titulo: 'Arquivo(s)',
                    thead:
                        <tr>
                            <td className='coluna-6'>Nome</td>
                            <td className='coluna-5'>Tamanho</td>
                            <td className='coluna-1 d-none-print'>Download</td>
                        </tr>,
                    tbody: dados.arquivo == undefined || dados.arquivo.length < 1 ? (<><tr>
                        <td colspan="3">Sem Registro!</td>
                    </tr></>) :
                        ordenarArrayObj(dados.arquivo, 'nome').map(arquivo =>
                            <tr>
                                <td>{arquivo.name}</td>
                                <td>{arquivo.sizeReadable}</td>
                                <td className="d-none-print"><div className="icone"><button className="btn-acao icon-Download-fromCloud" onClick={() => downloadArquivoS3(arquivo.s3Key)}></button></div></td>
                            </tr>)
                }
            ]
        else {
            data.assinatura = true
            data.grupos = [
                {
                    titulo: 'Dados Gerais',
                    colunas: [
                        {
                            titulo: 'Código',
                            descricao: dados.id,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Operação',
                            descricao: dados.operacao && dados.operacao.label,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Código de Barras',
                            descricao: dados.produto.codigo_barras,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Produto',
                            descricao: dados.produto.label,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Data Saída',
                            descricao: dados.data,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Quantidade',
                            descricao: dados.quantidade,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Responsável',
                            descricao: dados.responsavel && dados.responsavel.label,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Outro',
                            descricao: dados.outro,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Observação',
                            descricao: dados.observacao,
                            tamanho: 'col-lg-6'
                        }, {
                            titulo: 'Data Registro',
                            descricao: dados.data_registro,
                            tamanho: 'col-lg-6'
                        }
                    ]
                }, {
                    tipoGrupo: 'tabela',
                    titulo: 'Arquivo(s)',
                    thead:
                        <tr>
                            <td className='coluna-6'>Nome</td>
                            <td className='coluna-5'>Tamanho</td>
                            <td className='coluna-1 d-none-print'>Download</td>
                        </tr>,
                    tbody: dados.arquivo == undefined || dados.arquivo.length < 1 ? (<><tr>
                        <td colspan="3">Sem Registro!</td>
                    </tr></>) :
                        ordenarArrayObj(dados.arquivo, 'nome').map(arquivo =>
                            <tr>
                                <td>{arquivo.name}</td>
                                <td>{arquivo.sizeReadable}</td>
                                <td className="d-none-print"><div className="icone"><button className="btn-acao icon-Download-fromCloud" onClick={() => downloadArquivoS3(arquivo.s3Key)}></button></div></td>
                            </tr>)
                },
                dados.produto.bloco ? {
                    tipoGrupo: 'tabela',
                    titulo: 'Entrega de Blocos',
                    thead:
                        <tr>
                            <td className='coluna-1'>#</td>
                            <td className='coluna-6'>Código Inicial</td>
                            <td className='coluna-6'>Código Final</td>
                            <td className='coluna-6'>Quantidade</td>
                        </tr>,
                    tbody:
                        dados.codigo_barras && dados.codigo_barras.sort().map((x, index) =>
                            <tr>
                                <td>{index + 1}</td>
                                <td>{x.inicial}</td>
                                <td>{x.final}</td>
                                <td>{x.quantidade}</td>
                            </tr>)
                } : undefined,
            ]
        }
    }

    return <VisualizacaoPadrao data={data} id={id} {...props} />
}